/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gray_Deft_Slug_BaskInputs */

const en_gray_deft_slug_bask = /** @type {(inputs: Gray_Deft_Slug_BaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comments enabled`)
};

const de_gray_deft_slug_bask = /** @type {(inputs: Gray_Deft_Slug_BaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentare aktiviert`)
};

/**
* | output |
* | --- |
* | "Comments enabled" |
*
* @param {Gray_Deft_Slug_BaskInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gray_deft_slug_bask = /** @type {((inputs?: Gray_Deft_Slug_BaskInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gray_Deft_Slug_BaskInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gray_deft_slug_bask(inputs)
	return de_gray_deft_slug_bask(inputs)
});